import { fetchSearchFamilies } from '@gn-audio/core/api/product-catalogue/fetch-search-families';
import { fetchSearchGroups } from '@gn-audio/core/api/product-catalogue/fetch-search-groups';
import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { isMobile } from 'src/Foundation/Design/app/utils/is-mobile';
import { PfmMode } from '../models';
import { buildFilterQuery } from '../utils/build-filter-query';
var PfmController = (function () {
    function PfmController($scope, $q, urlHelper, loadQueue, productFilterModuleApiService) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.urlHelper = urlHelper;
        this.loadQueue = loadQueue;
        this.productFilterModuleApiService = productFilterModuleApiService;
        this.initialize();
        var $configurationIdWatcher = this.$scope.$watch('configurationId', function () {
            $configurationIdWatcher();
            _this.loadQueue.add('pfmcontroller#load-configuration');
            _this.productFilterModuleApiService.getConfiguration(_this.$scope.configurationId)
                .then(function (configuration) {
                _this.$scope.configuration = configuration;
                _this.handleOrderOptions();
                _this.handleFilterGroups();
                _this.$scope.load();
            })
                .finally(function () {
                _this.loadQueue.remove('pfmcontroller#load-configuration');
            });
        });
        var infiniteScrollWatcher = this.$scope.$watch('infiniteScroll', function () {
            _this.$scope.infiniteScroll = (_this.$scope.infiniteScroll !== 'false');
            infiniteScrollWatcher();
        });
    }
    PfmController.prototype.initialize = function () {
        var _this = this;
        this.$scope.searchOptions = { filter: '', search: this.urlHelper.searchQuery };
        this.$scope.orderOptions = { options: [] };
        this.$scope.pagingOptions = { changed: false, count: 0, currentPage: this.urlHelper.pageNumber, pageSize: 12 };
        this.$scope.loadedProducts = [];
        this.$scope.selectedFilters = [];
        this.$scope.hasLoadedProducts = function () {
            return _this.$scope.loadedProducts.length > 0;
        };
        this.$scope.isGroupType = function () {
            return _this.$scope.configuration.entityType === "g";
        };
        this.$scope.areFiltersOrSearchPhraseApplied = function () {
            var _a = _this.$scope, selectedFilters = _a.selectedFilters, searchOptions = _a.searchOptions;
            return selectedFilters.length > 0 || !!searchOptions.search;
        };
        this.$scope.loading = function () {
            return !_this.loadQueue.isEmpty();
        };
        this.$scope.hasCampaignId = function () {
            var _a;
            return !!((_a = _this.$scope.configuration) === null || _a === void 0 ? void 0 : _a.campaignId);
        };
        this.$scope.applyFilters = function () {
            smoothScroll(document.querySelector('.product-finder'), {
                callbackAfter: function () {
                    _this.$scope.pagingOptions.currentPage = 1;
                    _this.$scope.load(true);
                    _this.$scope.showFilters = false;
                }
            });
        };
        this.$scope.loadMore = function () {
            if (_this.$scope.loading()) {
                return;
            }
            if (_this.$scope.pagingOptions.changed && _this.$scope.loadedProducts.length === _this.$scope.pagingOptions.count) {
                return;
            }
            _this.$scope.pagingOptions.currentPage += 1;
            _this.$scope.load();
        };
        this.$scope.load = function (resetLoadedProducts) {
            if (resetLoadedProducts === void 0) { resetLoadedProducts = false; }
            var _a = _this.$scope, infiniteScroll = _a.infiniteScroll, mode = _a.mode, selectedFilters = _a.selectedFilters;
            var _b = _this.$scope.pagingOptions, pageSize = _b.pageSize, currentPage = _b.currentPage;
            if (!infiniteScroll) {
                _this.urlHelper.pageNumber = currentPage;
            }
            _this.loadQueue.add('pfmcontroller#loadMore');
            var _c = _this.$scope.configuration, filterGroups = _c.filterGroups, preFilterQuery = _c.preFilterQuery, campaignId = _c.campaignId;
            _this.$scope.searchOptions.filter = buildFilterQuery(filterGroups, selectedFilters, preFilterQuery);
            var _d = _this.$scope.searchOptions, filter = _d.filter, search = _d.search;
            var parameters = {
                campaignId: campaignId,
                filter: filter,
                search: search,
                skip: pageSize * (currentPage - 1),
                top: pageSize,
                includePrices: mode === PfmMode.Normal || mode === PfmMode.Compare,
            };
            var current = _this.$scope.orderOptions.current;
            if (current !== undefined) {
                parameters.orderBy = current.property + " " + current.direction;
            }
            var includeType = "available";
            if (mode !== PfmMode.Normal) {
                includeType = "supported";
            }
            var promise;
            switch (_this.$scope.configuration.entityType) {
                case "f":
                    promise = fetchSearchFamilies(parameters, includeType);
                    break;
                case "g":
                    promise = fetchSearchGroups(parameters, includeType);
                default:
                    break;
            }
            if (promise) {
                _this.$q
                    .when(promise)
                    .then(function (results) {
                    var searchItems = (results === null || results === void 0 ? void 0 : results.items) || [];
                    if (infiniteScroll && !resetLoadedProducts) {
                        searchItems.forEach(function (resultItem) {
                            _this.$scope.loadedProducts.push(resultItem);
                        });
                    }
                    else {
                        _this.$scope.loadedProducts = searchItems;
                    }
                    _this.$scope.loadedProducts.forEach(function (g) {
                        g.images = (g.images || [])
                            .filter(function (image) { return image.match(/.(jpg|jpeg|png|tiff|tif)/gi) !== null; });
                    });
                    _this.$scope.pagingOptions.count = (results === null || results === void 0 ? void 0 : results.count) || 0;
                    _this.$scope.pagingOptions.changed = true;
                }, function () {
                    _this.$scope.loadedProducts.length = 0;
                })
                    .finally(function () { _this.loadQueue.remove('pfmcontroller#loadMore'); });
            }
        };
        this.$scope.searchOptionsChanged = function (orderChanged) {
            if (orderChanged === void 0) { orderChanged = false; }
            _this.urlHelper.searchQuery = _this.$scope.searchOptions.search;
            if (isMobile() && !orderChanged) {
                return;
            }
            smoothScroll(document.querySelector('.product-finder'), {
                callbackAfter: function () {
                    _this.$scope.pagingOptions.changed = false;
                    _this.$scope.pagingOptions.count = 0;
                    _this.$scope.pagingOptions.currentPage = 1;
                    _this.$scope.load(true);
                }
            });
        };
        this.$scope.toggleFilter = function (filterId, filterGroup) {
            var filterIndex = _this.$scope.selectedFilters.indexOf(filterId);
            var filter = filterGroup.filters.filter(function (f) { return f.id === filterId; })[0];
            if (filterIndex === -1) {
                _this.$scope.selectedFilters.push(filterId);
                filterGroup.selected++;
                filter.selected = true;
            }
            else {
                _this.$scope.selectedFilters.splice(filterIndex, 1);
                filterGroup.selected--;
                filter.selected = false;
            }
            _this.urlHelper.filters = _this.$scope.selectedFilters.map(function (f) { return f.substring(f.length - 4); });
            _this.$scope.searchOptionsChanged();
        };
        this.$scope.orderChanged = function (order) {
            _this.$scope.orderOptions.current = order;
            _this.urlHelper.sorter = order.property.toLowerCase() + "-" + order.direction.toLowerCase();
            _this.$scope.searchOptionsChanged(true);
        };
    };
    PfmController.prototype.handleOrderOptions = function () {
        this.$scope.orderOptions.options = this.$scope.configuration.orders;
        var sorterParts = this.urlHelper.sorter.split('-');
        if (sorterParts.length > 0) {
            this.$scope.orderOptions.current = this.$scope.orderOptions.options.filter(function (o) {
                return (o.property.toLowerCase() === (sorterParts[0] || '').toLowerCase() &&
                    o.direction.toLowerCase() === (sorterParts[1] || '').toLowerCase());
            })[0];
            if (this.$scope.orderOptions.current === undefined) {
                this.$scope.orderOptions.current = this.$scope.orderOptions.options[0];
            }
        }
        else {
            this.$scope.orderOptions.current = this.$scope.orderOptions.options[0];
        }
        if (this.$scope.orderOptions.current !== undefined) {
            this.urlHelper.sorter = this.$scope.orderOptions.current.property.toLowerCase() + "-" + this.$scope.orderOptions.current.direction.toLowerCase();
        }
    };
    PfmController.prototype.handleFilterGroups = function () {
        this.$scope.configuration.filterGroups.forEach(function (fg) { fg.selected = 0; });
        for (var _i = 0, _a = this.$scope.configuration.filterGroups; _i < _a.length; _i++) {
            var filterGroup = _a[_i];
            var _loop_1 = function (filter) {
                filter.selected = this_1.urlHelper.filters.some(function (f) { return filter.id.indexOf(f) > -1; });
                if (filter.selected) {
                    this_1.$scope.selectedFilters.push(filter.id);
                    filterGroup.selected++;
                }
            };
            var this_1 = this;
            for (var _b = 0, _c = filterGroup.filters; _b < _c.length; _b++) {
                var filter = _c[_b];
                _loop_1(filter);
            }
        }
    };
    PfmController.$inject = ['$scope', '$q', 'pfmUrlHelper', 'pfmLoadQueue', 'productFilterModuleApiService'];
    return PfmController;
}());
export { PfmController };
